<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-09-30 22:55:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-03 20:55:34
 * @Description: file content
 -->
<template>
  <div class="boxBg">
    <img
      class="bg"
      src="http://assets.rurushishi.com/activies/caseCode/banner2.png"
    />

    <div class="item1" @click="scanCode">
      <img
        class="icon"
        src="http://assets.rurushishi.com/activies/caseCode/icon1.png"
      />
      <div class="submit">扫码核销</div>
    </div>
    <div class="item2">
      <input type="text" placeholder="请输入核销码" v-model="prizeCode" />
      <div class="submit" @click="getPrizeInfo">核销查询</div>
    </div>

    <div class="prizeInfo" v-if="showPrizeInfo">
      <img
        class="icon"
        :src="
          prizeInfo.prizeImg
            ? prizeInfo.prizeImg
            : 'http://assets.rurushishi.com/activies/fortune-cat/prize_icon.png'
        "
      />
      <div class="prizeItem">
        <div class="label">奖品名称</div>
        {{ prizeInfo.prizeName }}
      </div>
      <div class="prizeItem">
        <div class="label">所属项目</div>
        {{ prizeInfo.projectName }}
      </div>
      <div class="prizeItem">
        <div class="label">活动名称</div>
        {{ prizeInfo.actName }}
      </div>
      <div class="prizeItem">
        <div class="label">领奖时间</div>
        {{ prizeInfo.receiveStartTime | getFullTimes }}~<br />
        {{ prizeInfo.receiveEndTime | getFullTimes }}
      </div>
      <div class="prizeItem" >
        <div class="label">核销状态</div>
        {{ prizeInfo.prizeOffStatus==1?'已核销':'未核销' }}
      </div>
      <div class="prizeItem" v-if="prizeInfo.prizeOffStatus==1">
        <div class="label">核销时间</div>
        {{ prizeInfo.prizeWriteOffTime | getFullTimes }}
      </div>
      <div class="submit" @click="submit" v-if="prizeInfo.prizeOffStatus!=1">确认核销</div>
    </div>

    <div class="prizeInfo" v-if="success">
      <img
        class="icon2"
        src="http://assets.rurushishi.com/activies/caseCode/icon2.png"
      />
      <div class="successText">核销成功</div>
      <div class="prizeItem">
        <div class="label">奖品名称</div>
        {{ prizeInfo.prizeName }}
      </div>
      <div class="prizeItem">
        <div class="label">所属项目</div>
        {{ prizeInfo.projectName }}
      </div>
      <div class="prizeItem">
        <div class="label">活动名称</div>
        {{ prizeInfo.actName }}
      </div>
      <div class="prizeItem">
        <div class="label">领奖时间</div>
        {{ prizeInfo.receiveStartTime | getFullTimes }}~<br />
        {{ prizeInfo.receiveEndTime | getFullTimes }}
      </div>
      <div class="btnList">
        <div class="next" @click="next">继续核销</div>
        <div
          class="ok"
          @click="
            success = false;
            type = 'scanCode';
          "
        >
          完成
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { MessageBox } from "mint-ui";
export default {
  data() {
    return {
      id: "",
      isClick: false,
      configInfo: {},

      prizeCode: "",
      showPrizeInfo: false,
      prizeInfo: {},
      showReceiveInfo: false,
      receiveInfo: {},
      success: false,
      type: "",
    };
  },
  components: {},
  mounted() {
      this.$wx.hideOptionMenu();
  },
  filters: {
    getFullTimes(time) {
      let date = new Date(time);
      let m = date.getMonth() + 1;
      m <= 9 ? (m = "0" + m) : m;
      let d = date.getDate();
      d <= 9 ? (d = "0" + d) : d;
      let h = date.getHours();
      h <= 9 ? (h = "0" + h) : h;
      let m2 = date.getMinutes();
      m2 <= 9 ? (m2 = "0" + m2) : m2;
      let s = date.getSeconds();
      s <= 9 ? (s = "0" + s) : s;
      return (
        date.getFullYear() + "-" + m + "-" + d + " " + h + ":" + m2 + ":" + s
      );
    },
  },
  methods: {
    clear() {
      this.prizeCode = "";
    },
    submit() {
      let _self = this;
      if (!_self.isClick) {
        if (!_self.prizeCode) {
          return MessageBox.alert("请先输入核销码", "提示");
        }
        _self.isClick = true;
        _self.prizeCode = _self.prizeCode
          .toLowerCase()
          .replace(/(^\s*)|(\s*$)/g, "");
        let url =
          this.$apizt.action.writeOff.api + `?writeOffCode=${_self.prizeCode}&openId=${_self.$openid}`;
        if (this.$route.query.channel) {
          url += `&prizeOffChannelId=${this.$route.query.channel}`;
        }
        // const { data, result } = this.$httpzt.requestRestFul(url, {
        //   writeOffCode: _self.id,
        // });
        this.$httpdf.post(url, null).then((data) => {
          if (data.code == 200) {
            return _self.$showModal("兑奖成功！", "提示").then(() => {
              _self.isClick = false;
              _self.showPrizeInfo = false;
              _self.clear();
            });
          } else {
            _self.isClick = false;
            _self.showPrizeInfo = false;
            _self.clear();
            _self.$showModal(data.msg || "网络错误,请重试!");
          }
        });
      }
    },

    scanCode() {
      this.type = "scanCode";
      this.$wx.ready(() => {
        this.$wx.scanQRCode().then((res) => {
          let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          this.prizeCode = result;
          this.getPrizeInfo();
        });
      });
    },

    getPrizeInfo() {
      let _self = this;
      _self.prizeCode = _self.prizeCode
        .toLowerCase()
        .replace(/(^\s*)|(\s*$)/g, "");
      let url = this.$apizt.action.getPrizeInfo.api + `/${_self.prizeCode}`;
      this.$httpdf.post(url, null).then((data) => {
        if (data.code == 200) {
          if (!data.data) {
            return MessageBox.alert("兑奖码无效").then(() => {
              _self.isClick = false;
            });
          } else {
            this.prizeInfo = data.data;
            this.showPrizeInfo = true;
          }
        } else {
          _self.isClick = false;
          _self.$showModal(data.msg || "网络错误,请重试!");
        }
      });
    },
    next() {
      this.success = false;
      if (this.type == "scanCode") {
        this.scanCode();
      }
    },
  },
  created() {},
};
</script>
<style lang="stylus" scoped>
.boxBg {
  position: relative;
  width: 100%;
  height: 100vh;
  background: #F5F5F5;
  display: flex;
  flex-direction: column;
}

.bg {
  width: 100%;
}

.item1 {
  position: relative;
  width: 343px;
  // height: 148px;
  background: linear-gradient(180deg, #EEF6FF 0%, #FFFFFF 32.89%);
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: -42px auto 0;
  padding: 16px 2%;
  box-sizing: border-box;

  .icon {
    width: 64px;
  }

  .submit {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #333333;
    margin-top: 12px;
  }
}

.item2 {
  width: 343px;
  background: linear-gradient(180deg, #EEF6FF 0%, #FFFFFF 24.29%);
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 14px 12px;
  box-sizing: border-box;
  margin: 16px auto 0;

  input {
    width: 311px;
    height: 40px;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px;
    box-sizing: border-box;
    font-size: 14px;
  }

  .submit {
    width: 311px;
    height: 44px;
    margin-top: 24px;
    background: linear-gradient(246.1deg, #F78A26 1.28%, #FCB125 67.84%), linear-gradient(50.05deg, #F78A26 -12.87%, #FCB125 90.01%), linear-gradient(270deg, #3B85F3 0%, #68B4FA 100%);
    border-radius: 6px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 44px;
    text-align: center;
    color: #FFFFFF;
  }
}

.item3 {
  position: relative;
  width: 343px;
  // height: 148px;
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px auto;
  padding: 16px 2%;
  box-sizing: border-box;
  flex: 1;
  overflow: scroll;

  .statusList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 10px;

    .statusItem {
      flex: 1;
      text-align: center;
    }

    .select {
      color: #f78a26;
    }
  }

  .receiveList {
    width: 100%;
    height: 100%;
    overflow: scroll;

    .item {
      line-height: 20px;
      padding: 10px 0;
      border-bottom: solid 1px #ccc;

      .itemName {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .itemInfo {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .noData {
      text-align: center;
      margin-top: 20px;
    }

    .item:last-child {
      margin-bottom: 0;
      border-bottom: none;
    }
  }
}

.prizeInfo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 32px;
  box-sizing: border-box;

  .icon {
    width: 120px;
    height: 120px;
    border-radius: 8px;
    margin-bottom: 32px;
  }

  .icon2 {
    width: 60px;
    margin-bottom: 16px;
  }

  .successText {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 32px;
    text-align: center;
    color: #000000;
    margin-bottom: 48px;
  }

  .prizeItem {
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    margin-bottom: 12px;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;

    .label {
      color: #A3AFBF;
      margin-right: 5px;
      width: 80px;
    }

    input {
      border: 1px solid #E5E5E5;
      box-sizing: border-box;
      border-radius: 4px;
      padding: 10px;
      box-sizing: border-box;
      font-size: 14px;
      height: 30px;
    }
  }

  .submit {
    width: 311px;
    height: 44px;
    margin-top: 28px;
    background: linear-gradient(246.1deg, #F78A26 1.28%, #FCB125 67.84%), linear-gradient(50.05deg, #F78A26 -12.87%, #FCB125 90.01%), linear-gradient(270deg, #3B85F3 0%, #68B4FA 100%);
    border-radius: 6px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 44px;
    text-align: center;
    color: #FFFFFF;
  }

  .btnList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 40px;
    padding: 0 30px;
    box-sizing: border-box;

    .next {
      width: 155.5px;
      height: 44px;
      left: 24px;
      top: 12px;
      border: 1px solid #F99336;
      box-sizing: border-box;
      border-radius: 5px;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 44px;
      text-align: center;
      color: #F99336;
    }

    .ok {
      width: 155.5px;
      height: 44px;
      background: linear-gradient(246.1deg, #F78A26 1.28%, #FCB125 67.84%), linear-gradient(50.05deg, #F78A26 -12.87%, #FCB125 90.01%), linear-gradient(270deg, #3B85F3 0%, #68B4FA 100%);
      border-radius: 6px;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 44px;
      text-align: center;
      color: #FFFFFF;
    }
  }

  .btnList2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 40px;
    padding: 0 30px;
    box-sizing: border-box;

    .ok {
      width: 45%;
      height: 44px;
      background: linear-gradient(246.1deg, #F78A26 1.28%, #FCB125 67.84%), linear-gradient(50.05deg, #F78A26 -12.87%, #FCB125 90.01%), linear-gradient(270deg, #3B85F3 0%, #68B4FA 100%);
      border-radius: 6px;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 44px;
      text-align: center;
      color: #FFFFFF;
    }
  }

  .next2 {
    width: 155.5px;
    height: 44px;
    border: 1px solid #F99336;
    box-sizing: border-box;
    border-radius: 5px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 44px;
    text-align: center;
    color: #F99336;
    margin-top: 20px;
  }
}
</style>
